import { Injectable } from '@angular/core';
import { BandTooltipStrategy } from './band-tooltip-strategy.interface';
import { PixxelBandTooltipStrategy } from './pixxel-band-tooltip.strategy';
import { WyvernBandTooltipStrategy } from './wyvern-band-tooltip.strategy';
import { OskBandTooltipStrategy } from './osk-band-tooltip.strategy';

@Injectable({ providedIn: 'root' })
export class BandTooltipResolverService {
  private strategies: BandTooltipStrategy[] = [
    new PixxelBandTooltipStrategy(),
    new WyvernBandTooltipStrategy(),
    new OskBandTooltipStrategy(),
  ];

  resolveTooltip(operatorKey: string, operatorMetadata: any, taskSensor: any): string {
    for (const strategy of this.strategies) {
      if (strategy.matches(operatorKey, operatorMetadata, taskSensor)) {
        return strategy.buildTooltip(operatorMetadata, taskSensor);
      }
    }
    return '';
  }
}
